import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { BetStatus, freeBetStore, useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { turboGameService } from '../../services/TurboGameService';
import { cardsStore } from '../../store/cardsStore';

export const DealSection = observer(() => {
  const { setDouble, setHalve, selectedAmount } = doBetStore;
  const { tableCards } = cardsStore;
  const { isBetsClosed, roundStatus, isAllowSendToInvoke } = gameStore;
  const { balance } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const { limits } = gameConfigStore;
  const t = useTranslation();

  const handleDeal = useCallback(() => {
    if (roundStatus === BetStatus.Pending && isAllowSendToInvoke) {
      turboGameService.sendHold();
    } else {
      turboGameService.sendBet();
    }
  }, [roundStatus, isAllowSendToInvoke]);

  return (
    <>
      <div
        className={`small-button-container small-r ${
          isBetsClosed ||
          selectedAmount === limits?.maxBet ||
          balance < selectedAmount * 2 ||
          activeFreeBet.id
            ? 'inactive'
            : ''
        }`}
        onClick={setDouble}
      >
        <div className='small-button'>
          <span className='small-button-text'>x2</span>
        </div>
      </div>
      <div
        className={`main-button-container ${roundStatus === BetStatus.Pending ? 'draw' : ''} ${
          !tableCards.length && isBetsClosed ? 'inactive' : ''
        }`}
        onClick={handleDeal}
      >
        <div className='main-button'>
          <span className={`main-button-text `}>
            {roundStatus === BetStatus.Pending ? t('DRAW') : t('DEAL')}
          </span>
        </div>
      </div>
      <div
        className={`small-button-container small-l ${
          isBetsClosed || selectedAmount === limits?.minBet || activeFreeBet.id ? 'inactive' : ''
        }`}
        onClick={setHalve}
      >
        <div className='small-button'>
          <span className='small-button-text'>1/2</span>
        </div>
      </div>
    </>
  );
});
